/*Clase Token, contiene credenciales y token para
  acceso a servicios de plexi-rest */
export class Token{

        //constructor de la clase
        constructor(

          //id del token
          public tokenId:string,

          //indica el estado del token
          public estado:number,

          //Contenido del token jwe
          public token:string,

          //id de la credencial del usuario
          public credentialId:number,

          //Tipo de usuario que inicia sesion
          public userType:number,

          //Mensaje de error
          public message:string,
        
          //flag para identificar si ya el usuario se autenticó
          public loginFlag: number,

          //sesion para online
          public sesion: number = 1,

          /** identificacion unico por sesion  permite tener solo un abierto */
          public uuidSesion: string,
          public cantidadSesionAnterior: number,

          public snp: string

        ){}
}
